import * as types from './mutation-types'

export default {

    [types.ADD_PERMISSIONS] (state, permissions) {

        if(Array.isArray(permissions)){
            state.permissions = permissions
        }else {
            state.permissions = Object.values(permissions)
        }
    },
    [types.SET_PERMISSIONS_BY_TEAM] (state, permissionsByTeam) {
        if (Array.isArray(permissionsByTeam)) {
            state.permissionsByTeam = permissionsByTeam
        } else if (permissionsByTeam && typeof permissionsByTeam === 'object') {
            state.permissionsByTeam = Object.values(permissionsByTeam)
        } else {
            state.permissionsByTeam = []
        }
    },
    [types.SET_ACTIVE_TEAM] (state, teamId) {
        state.activeTeamId = teamId || null
    },
    [types.LOAD_PERMISSIONS] (state, data) {
        let permissions = data.data
        if(Array.isArray(permissions)){
            state.all = permissions
        }else {
            state.all = Object.values(permissions)
        }
    }

    
}
